module.exports = __webpack_public_path__ + "static/media/In.f93b21e0.svg";